export enum ControllerTabs {
  General = 'general',
  History = 'history',
}
